import isEmpty from 'lodash/isEmpty'

import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import requests from 'app/requests/CQuote/CQuote.requests'
import {
    ContractCurrency, ProductTypeCQuote,
    CollectionServiceType, DeliveryServiceType,
} from 'app/enums/label.enums'

export type FeesRequestData = {
    expPalletsYear: number,
    rentalDays: number,
    logisticsDays: number,
} & ({
    lane: { id: number },
} | {
    productType: ProductTypeCQuote,
    originAirport: { id: number },
    destinationAirport: { id: number },
    deliveryServiceType: DeliveryServiceType,
    collectionServiceType: CollectionServiceType,
    handoverPoint: { id: number },
    collectionDropoffPoint: { id: number },
    currency: ContractCurrency,
})

export default function useGetCQuotesFeesData(requestData: FeesRequestData) {
    return useRequest({
        key: RequestKeys.getCQuoteFeesData,
        params: requestData,
        requestFunc: RequestFn.getEntity(requests.getCQuoteFeesData),
        enabled: !isEmpty(requestData),
    })
}
